import * as React from 'react';

import { cn } from '../../../../helpers/Utils';

import type { FileSuccessfulProps } from './FileSuccessful.props';

function nope(event: React.MouseEvent<HTMLAnchorElement>) {}

const FileSuccessful = ({
  file,
  checkIsAuth,
  isBase64,
  isClicked,
}: FileSuccessfulProps) => {
  const nameIcon =
    (file?.name || file?.value || '')?.split('.')?.pop()?.toLowerCase() ||
    'unknown';

  const fileName = file?.name || file?.value;

  return (
    <span
      className={cn('input-group--file', {
        wait: !!isClicked,
      })}
      style={{ width: '1%', flex: '1 0 auto' }}
    >
      <div className="form-control form-control--file">
        <label className="file-load">
          <a
            download
            href={file.url}
            target="__blank"
            onClick={isBase64 ? nope : checkIsAuth}
          >
            <span className="row valign">
              <span className={`fileicon fileicon-${nameIcon}`} />
              <span
                className="control-label control-label--file"
                title={fileName}
              >
                {isClicked ? 'Скачивается' : fileName}
              </span>
            </span>
          </a>
        </label>
      </div>
    </span>
  );
};

export { FileSuccessful };
